module.exports = __webpack_public_path__ + "img/1f13cfe.png";